import {
	playerReportSchema,
	playerReportSummarySchema,
	type ReportStatus,
	type UpdateReportStatus,
} from "../schemas/report";
import { fetchApi, paginatedSchema } from "./internal";

export const playerReports = {
	list: (status: ReportStatus | "all" = "open", limit = 50, offset = 0) =>
		fetchApi(
			`/admin/profiles/reports?status=${status}&limit=${limit}&offset=${offset}`,
			paginatedSchema(playerReportSchema),
		),
	summary: (status: ReportStatus | "all" = "open", limit = 50, offset = 0) =>
		fetchApi(
			`/admin/profiles/reports/summary?status=${status}&limit=${limit}&offset=${offset}`,
			paginatedSchema(playerReportSummarySchema),
		),
	listByPlayer: (playerId: string, status: ReportStatus | "all" = "all", limit = 50, offset = 0) =>
		fetchApi(
			`/admin/profiles/${playerId}/reports?status=${status}&limit=${limit}&offset=${offset}`,
			paginatedSchema(playerReportSchema),
		),
	updateStatus: (id: string, body: UpdateReportStatus) =>
		fetchApi(`/admin/profiles/reports/${id}`, playerReportSchema, {
			method: "PATCH",
			body: JSON.stringify(body),
		}),
};
